// -----------------------------------------------------------------------------
// i18n — Traductions FR / AR
// StockPro / VisualisPro
//
// 📌 NOTE POUR YOUSSEF :
// Ce fichier contient TOUTES les catégories et zones de stockage de StockPro.
// Pour ajouter une nouvelle catégorie ou zone :
//   1. Modifie ce fichier (les 2 sections : `fr` ET `ar`)
//   2. Sauvegarde
//   3. Push sur GitHub → Vercel redéploie automatiquement
//   4. Tes clients verront les nouveaux choix dans le formulaire d'ajout produit
//
// ➕ POUR AJOUTER UNE CATÉGORIE :
//    Va à la ligne `cats: [...]` et ajoute ton mot entre guillemets et une virgule
//    Exemple : "Sauces", "Snacks", "Pâtes fraîches"
//    ⚠️ Fais-le DANS LES DEUX sections (fr ET ar)
//
// ➕ POUR AJOUTER UNE ZONE DE STOCKAGE :
//    Va à la ligne `zones: {...}` et ajoute "Nom":"Nom"
//    Exemple : "Étagère haute":"Étagère haute"
//    ⚠️ Fais-le DANS LES DEUX sections (fr ET ar)
//    Côté arabe, mets la traduction arabe à droite
// -----------------------------------------------------------------------------

export const T = {
  fr: {
    appName: "StockPro", by: "par VisualisPro",
    login: "Se connecter", email: "Email", password: "Mot de passe",
    wrongCreds: "Email ou mot de passe incorrect", loading: "Chargement...",
    dashboard: "Tableau de bord", products: "Produits", alerts: "Alertes",
    history: "Historique", inventory: "Inventaire", licence: "Licence",
    contact: "Nous contacter", settings: "Paramètres", logout: "Déconnexion",
    addProduct: "Ajouter", search: "Rechercher...", all: "Tous",
    name: "Nom", category: "Catégorie", unit: "Unité", quantity: "Quantité",
    alertAt: "Alerte si =", price: "Prix unitaire (€)", zone: "Zone",
    dlc: "Date limite (DLC)", save: "Sauvegarder", cancel: "Annuler",
    delete: "Supprimer", edit: "Modifier",
    confirmDelete: "Supprimer ce produit ?",
    irreversible: "Le produit sera masqué (récupérable par l'agence).",
    noProducts: "Aucun produit", stockValue: "Valeur du stock",
    totalProducts: "Produits", criticalAlerts: "Alertes critiques",
    categories: "Catégories", exportList: "Liste de courses",
    exportedOk: "Liste exportée ✓", noAlerts: "Aucun produit en alerte",
    allGood: "Tous les stocks sont OK !", orderAt: "Commander au moins",
    toSafeZone: "pour zone sécurisée",
    inventoryMode: "Inventaire", physicalQty: "Quantité réelle",
    theoreticalQty: "Stock actuel", difference: "Écart",
    applyInventory: "Appliquer", inventoryApplied: "Inventaire appliqué ✓",
    scanBarcode: "Scanner", stopScan: "Arrêter",
    productFound: "Trouvé !", productNotFound: "Introuvable",
    addedOk: "Produit ajouté ✓", updatedOk: "Mis à jour ✓", deletedOk: "Produit supprimé ✓",
    fillFields: "Remplissez les champs obligatoires",
    dlcExpired: "Expiré !", dlcSoon: "Expire bientôt",
    noHistory: "Aucun mouvement",
    theme: "Thème", dark: "Sombre", light: "Clair", lang: "Langue",
    offlineMode: "Mode hors-ligne",
    saving: "Sauvegarde...", synced: "Synchronisé ✓", syncError: "Erreur sync",
    licenceTitle: "Licence", licenceActive: "Active ✓", licenceExpired: "Expirée ✗",
    licenceTrial: "Essai 14j", licenceMonthly: "Mensuelle", licenceContract: "Contrat",
    licenceEnterKey: "Entrer une clé", licenceActivate: "Activer",
    licenceActivated: "Licence activée ✓", licenceInvalid: "Clé invalide",
    licenceDaysLeft: "jours restants", licenceRenew: "Renouveler",
    licenceTrialInfo: "14 jours d'essai gratuit inclus",
    contactTitle: "Nous contacter", contactSubtitle: "Réponse en moins de 2h",
    contactWhatsApp: "WhatsApp", contactEmail: "Email",
    contactHours: "Disponible", contactHoursVal: "Lun-Sam · 9h-19h",
    contactResponseTime: "Temps de réponse", contactResponseVal: "< 2 heures",
    sellPrice: "Prix de vente (€)", foodCost: "Food Cost", margin: "Marge",
    foodCostTitle: "Food Cost & Marges", foodCostGreen: "Seuil vert (%)", foodCostOrange: "Seuil orange (%)",
    noFoodCost: "Aucun prix de vente renseigné", bestMargin: "Meilleure marge", worstMargin: "Marge la plus faible",
    avgFoodCost: "Food cost moyen",

    // 🗂️ ZONES DE STOCKAGE — AJOUTE TES NOUVELLES ZONES ICI
    // Format : "Nom":"Nom" — sépare chaque zone par une virgule
    zones: {
      "Réserve sèche": "Réserve sèche",
      "Chambre froide": "Chambre froide",
      "Comptoir": "Comptoir",
      "Cave": "Cave",
      "Congélateur": "Congélateur",
      "Étagère haute": "Étagère haute",      // ✨ NOUVELLE
      "Étagère basse": "Étagère basse",      // ✨ NOUVELLE
      "Tiroir frigo": "Tiroir frigo",        // ✨ NOUVELLE
      "Bar": "Bar",                          // ✨ NOUVELLE
      "Cuisine": "Cuisine",                  // ✨ NOUVELLE
      "Autre": "Autre"
    },

    units: ["pcs", "kg", "litres", "grammes", "bouteilles", "boîtes", "sachets", "tranches"],

    // 📋 CATÉGORIES — AJOUTE TES NOUVELLES CATÉGORIES ICI
    // Sépare chaque catégorie par une virgule, garde "Autre" à la fin
    cats: [
      "Boissons",
      "Viande",
      "Poisson",          // ✨ NOUVELLE
      "Fromage",
      "Boulangerie",
      "Féculents",
      "Pâtes fraîches",   // ✨ NOUVELLE
      "Sauces",           // ✨ NOUVELLE (demandée par tes clients)
      "Condiments",
      "Conserves",
      "Légumes",
      "Fruits",
      "Épices",
      "Surgelés",
      "Snacks",           // ✨ NOUVELLE
      "Desserts",         // ✨ NOUVELLE
      "Produits laitiers",// ✨ NOUVELLE
      "Emballages",       // ✨ NOUVELLE
      "Autre"
    ],
  },
  ar: {
    appName: "ستوك برو", by: "من VisualisPro",
    login: "تسجيل الدخول", email: "البريد الإلكتروني", password: "كلمة المرور",
    wrongCreds: "بريد أو كلمة مرور خاطئة", loading: "جار التحميل...",
    dashboard: "لوحة القيادة", products: "المنتجات", alerts: "التنبيهات",
    history: "السجل", inventory: "الجرد", licence: "الرخصة",
    contact: "اتصل بنا", settings: "الإعدادات", logout: "تسجيل الخروج",
    addProduct: "إضافة", search: "بحث...", all: "الكل",
    name: "الاسم", category: "الفئة", unit: "الوحدة", quantity: "الكمية",
    alertAt: "تنبيه عند =", price: "السعر (€)", zone: "المنطقة",
    dlc: "تاريخ الانتهاء", save: "حفظ", cancel: "إلغاء",
    delete: "حذف", edit: "تعديل",
    confirmDelete: "حذف هذا المنتج؟",
    irreversible: "سيتم إخفاء المنتج (قابل للاسترجاع).",
    noProducts: "لا توجد منتجات", stockValue: "قيمة المخزون",
    totalProducts: "المنتجات", criticalAlerts: "تنبيهات حرجة",
    categories: "الفئات", exportList: "قائمة التسوق",
    exportedOk: "تم التصدير ✓", noAlerts: "لا توجد تنبيهات",
    allGood: "جميع المخزونات بخير!", orderAt: "اطلب على الأقل",
    toSafeZone: "للمنطقة الآمنة",
    inventoryMode: "الجرد", physicalQty: "الكمية الفعلية",
    theoreticalQty: "المخزون الحالي", difference: "الفرق",
    applyInventory: "تطبيق", inventoryApplied: "تم تطبيق الجرد ✓",
    scanBarcode: "مسح", stopScan: "إيقاف",
    productFound: "تم العثور!", productNotFound: "غير موجود",
    addedOk: "تمت الإضافة ✓", updatedOk: "تم التحديث ✓", deletedOk: "تم الحذف ✓",
    fillFields: "يرجى ملء الحقول المطلوبة",
    dlcExpired: "منتهي!", dlcSoon: "ينتهي قريباً",
    noHistory: "لا توجد حركات",
    theme: "المظهر", dark: "داكن", light: "فاتح", lang: "اللغة",
    offlineMode: "وضع عدم الاتصال",
    saving: "جار الحفظ...", synced: "متزامن ✓", syncError: "خطأ في المزامنة",
    licenceTitle: "الرخصة", licenceActive: "نشطة ✓", licenceExpired: "منتهية ✗",
    licenceTrial: "تجريبي", licenceMonthly: "شهري", licenceContract: "عقد",
    licenceEnterKey: "أدخل المفتاح", licenceActivate: "تفعيل",
    licenceActivated: "تم التفعيل ✓", licenceInvalid: "مفتاح غير صالح",
    licenceDaysLeft: "أيام متبقية", licenceRenew: "تجديد",
    licenceTrialInfo: "14 يوم تجريبي مجاني",
    contactTitle: "اتصل بنا", contactSubtitle: "رد خلال ساعتين",
    contactWhatsApp: "واتساب", contactEmail: "البريد",
    contactHours: "متاح", contactHoursVal: "الإثنين-السبت · 9-19",
    contactResponseTime: "وقت الرد", contactResponseVal: "< ساعتان",
    sellPrice: "سعر البيع (€)", foodCost: "تكلفة الغذاء", margin: "الهامش",
    foodCostTitle: "تكلفة الغذاء والهوامش", foodCostGreen: "الحد الأخضر (%)", foodCostOrange: "الحد البرتقالي (%)",
    noFoodCost: "لا يوجد سعر بيع", bestMargin: "أفضل هامش", worstMargin: "أضعف هامش",
    avgFoodCost: "متوسط تكلفة الغذاء",

    // 🗂️ ZONES (version arabe) — Mets la traduction arabe à droite
    zones: {
      "Réserve sèche": "مخزن جاف",
      "Chambre froide": "غرفة باردة",
      "Comptoir": "كاونتر",
      "Cave": "قبو",
      "Congélateur": "مجمد",
      "Étagère haute": "رف علوي",        // ✨ NOUVELLE
      "Étagère basse": "رف سفلي",        // ✨ NOUVELLE
      "Tiroir frigo": "درج الثلاجة",     // ✨ NOUVELLE
      "Bar": "البار",                    // ✨ NOUVELLE
      "Cuisine": "المطبخ",               // ✨ NOUVELLE
      "Autre": "أخرى"
    },

    units: ["قطعة", "كغ", "لتر", "غرام", "زجاجة", "علبة", "كيس", "شريحة"],

    // 📋 CATÉGORIES (version arabe)
    cats: [
      "مشروبات",
      "لحم",
      "سمك",              // ✨ NOUVELLE
      "جبن",
      "مخبوزات",
      "نشويات",
      "معكرونة طازجة",    // ✨ NOUVELLE
      "صلصات",            // ✨ NOUVELLE (Sauces)
      "توابل",
      "معلبات",
      "خضروات",
      "فواكه",
      "بهارات",
      "مجمدات",
      "وجبات خفيفة",      // ✨ NOUVELLE
      "حلويات",           // ✨ NOUVELLE
      "منتجات الألبان",   // ✨ NOUVELLE
      "تغليف",            // ✨ NOUVELLE
      "أخرى"
    ],
  },
};

export default T;
